import { render, staticRenderFns } from "./Userquestion.vue?vue&type=template&id=56e632f6&scoped=true"
import script from "./Userquestion.vue?vue&type=script&lang=js"
export * from "./Userquestion.vue?vue&type=script&lang=js"
import style0 from "./Userquestion.vue?vue&type=style&index=0&id=56e632f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e632f6",
  null
  
)

export default component.exports